import * as React from "react";
const SvgPrimaryEdit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#082B60"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.25}
      d="M7.235 2.773a4.555 4.555 0 0 0 4.052 3.829M.624 15.375h13.383M8.253 1.695 2.15 8.155c-.23.246-.453.73-.498 1.064l-.275 2.409c-.097.87.528 1.464 1.39 1.316l2.394-.41c.335-.059.803-.304 1.034-.557l6.104-6.46c1.055-1.116 1.531-2.387-.112-3.941C10.55.037 9.31.58 8.253 1.695"
    />
  </svg>
);
export default SvgPrimaryEdit;
